import {RecommendationMessagesElement} from "./RecommendationMessagesElement";

const COLOR = "#2563EB";

export function RecommendationsInformationElement({
    messages,
    locale,
    printMode = false
}: {
    messages: Record<string, string>[] | undefined;
    locale: string;
    printMode?: boolean;
}) {
    return (
        <RecommendationMessagesElement
            messages={messages}
            locale={locale}
            color={COLOR}
            borderOpacity={0.24}
            printMode={printMode}
        />
    );
}
